export enum VOICE_TONES {
  FRIENDLY = 'Friendly',
  FUNNY = 'Funny',
  RELAXED = 'Relaxed',
  DIRECT = 'Direct',
  ENGAGING = 'Engaging',
  PASSIONATE = 'Passionate',
  PROFESSIONAL = 'Professional',
  MYSTERIOUS = 'Mysterious',
  WITTY = 'Witty',
  PERSONABLE = 'Personable',
  CONFIDENT = 'Confident',
  EMPATHETIC = 'Empathetic',
}

export enum VOICE_FORMALITY {
  CASUAL = 'Casual',
  NEUTRAL = 'Neutral',
  FORMAL = 'Formal',
}

export const COMING_SOON_FEATURES = [
  'Advanced MyBrand Voice™',
  'Priority Input to Roadmap',
  'Ecommerce Integrations',
  'Private Community Access',
  'Custom Workflows',
  'Smart Mockups Per Image',
  'Make Your Own Custom Sparks',
  'Social Media Integrations',
];

export enum STRIPE_SUBSCRIPTION_ACTIVE_STATUSES {
  ACTIVE = 'active',
  PAST_DUE = 'past_due',
  UNPAID = 'unpaid',
  PAUSED = 'paused',
  TRIALING = 'trialing',
}

export const DEFAULT_SIZES = [
  // Common sizes (8" base)
  { width: 8, height: 8 },
  { width: 8, height: 10 },
  { width: 10, height: 8 },
  { width: 8, height: 11 },
  { width: 11, height: 8 },
  { width: 8, height: 12 },
  { width: 12, height: 8 },
  { width: 8, height: 13 },
  { width: 13, height: 8 },
  { width: 8, height: 14 },
  { width: 14, height: 8 },
  { width: 8, height: 16 },
  { width: 16, height: 8 },

  // 10" base sizes
  { width: 10, height: 12 },
  { width: 12, height: 10 },
  { width: 10, height: 13 },
  { width: 13, height: 10 },
  { width: 10, height: 14 },
  { width: 10, height: 20 },

  // Medium sizes (12" base)
  { width: 12, height: 12 },
  { width: 12, height: 15 },
  { width: 15, height: 12 },
  { width: 12, height: 16 },
  { width: 16, height: 12 },
  { width: 12, height: 17 },
  { width: 17, height: 12 },
  { width: 12, height: 18 },
  { width: 18, height: 12 },
  { width: 12, height: 19 },
  { width: 19, height: 12 },
  { width: 12, height: 21 },
  { width: 21, height: 12 },
  { width: 12, height: 24 },
  { width: 24, height: 12 },

  // Large sizes (16" base)
  { width: 16, height: 16 },
  { width: 16, height: 20 },
  { width: 20, height: 16 },
  { width: 16, height: 21 },
  { width: 21, height: 16 },
  { width: 16, height: 22 },
  { width: 22, height: 16 },
  { width: 16, height: 24 },
  { width: 24, height: 16 },
  { width: 16, height: 26 },
  { width: 26, height: 16 },
  { width: 16, height: 28 },
  { width: 28, height: 16 },
  { width: 16, height: 32 },
  { width: 32, height: 16 },

  // Extra large sizes (20" base)
  { width: 20, height: 20 },
  { width: 20, height: 24 },
  { width: 24, height: 20 },
  { width: 20, height: 25 },
  { width: 25, height: 20 },
  { width: 20, height: 26 },
  { width: 26, height: 20 },
  { width: 20, height: 27 },
  { width: 27, height: 20 },
  { width: 20, height: 28 },
  { width: 28, height: 20 },
  { width: 20, height: 30 },
  { width: 30, height: 20 },
  { width: 20, height: 32 },
  { width: 32, height: 20 },
  { width: 20, height: 36 },
  { width: 36, height: 20 },
  { width: 20, height: 40 },
  { width: 40, height: 20 },

  // Gallery sizes (24" base)
  { width: 24, height: 24 },
  { width: 24, height: 30 },
  { width: 30, height: 24 },
  { width: 24, height: 31 },
  { width: 31, height: 24 },
  { width: 24, height: 32 },
  { width: 32, height: 24 },
  { width: 24, height: 34 },
  { width: 34, height: 24 },
  { width: 24, height: 36 },
  { width: 36, height: 24 },
  { width: 24, height: 38 },
  { width: 38, height: 24 },
  { width: 24, height: 43 },
  { width: 43, height: 24 },

  // Statement sizes (30" base)
  { width: 30, height: 30 },
  { width: 30, height: 38 },
  { width: 38, height: 30 },
  { width: 30, height: 40 },
  { width: 40, height: 30 },
  { width: 30, height: 42 },
  { width: 42, height: 30 },
  { width: 30, height: 45 },
  { width: 45, height: 30 },
  { width: 30, height: 48 },
  { width: 48, height: 30 },
  { width: 30, height: 53 },
  { width: 53, height: 30 },

  // 35" base sizes
  { width: 35, height: 35 },
  { width: 35, height: 44 },
  { width: 44, height: 35 },
  { width: 35, height: 45 },
  { width: 45, height: 35 },
  { width: 35, height: 46 },
  { width: 46, height: 35 },
  { width: 35, height: 47 },
  { width: 47, height: 35 },
  { width: 35, height: 49 },
  { width: 49, height: 35 },
  { width: 35, height: 56 },
  { width: 56, height: 35 },
  { width: 35, height: 62 },
  { width: 62, height: 35 },

  // 40" base sizes
  { width: 40, height: 40 },
  { width: 40, height: 51 },
  { width: 51, height: 40 },
  { width: 40, height: 53 },
  { width: 53, height: 40 },
  { width: 40, height: 56 },
  { width: 56, height: 40 },
  { width: 40, height: 64 },
  { width: 64, height: 40 },
  { width: 40, height: 71 },
  { width: 71, height: 40 },

  // Additional sizes
  { width: 18, height: 6 },
  { width: 18, height: 25 },
  { width: 18, height: 36 },
  { width: 25, height: 8 },
  { width: 28, height: 38 },
  { width: 38, height: 28 },
  { width: 39, height: 50 },
  { width: 50, height: 39 },
] as const;
